import React, { forwardRef, useImperativeHandle, useRef } from 'react';
import { Category } from '../../../../apiServices/types';
import { GlassSelect, GlassSelectRef } from '../../../UI';
import { DeleteIcon } from '../../../UI/Icons';
import { ValidationConstants, ValidationUtils } from '../../../../utils';

export interface CategoryInputRef {
  focus: () => void;
}

interface CategoryInputProps {
  value: string;
  categories: Category[];
  onChange: (value: string) => void;
  onRemove: () => void;
}

const CategoryInput = forwardRef<CategoryInputRef, CategoryInputProps>(({
  value,
  categories,
  onChange,
  onRemove
}, ref) => {
  const glassSelectRef = useRef<GlassSelectRef>(null);

  useImperativeHandle(ref, () => ({
    focus: () => {
      glassSelectRef.current?.focus();
    }
  }));
  const categoryOptions = categories.map(cat => ({
    value: cat.name,
    label: cat.name
  }));

  const handleCustomValue = (customValue: string) => {
    if (customValue.length >= ValidationConstants.Category.NameMinLength && 
        customValue.length <= ValidationConstants.Category.NameMaxLength &&
        !ValidationUtils.containsForbiddenChars(customValue)) {
      onChange(customValue);
    }
  };

  return (
    <div className="category-header">
      <div className="category-input-wrapper">
        <GlassSelect
          ref={glassSelectRef}
          options={categoryOptions}
          value={value}
          onChange={onChange}
          placeholder="Назва категорії"
          searchable={true}
          allowCustomValue={true}
          onCustomValue={handleCustomValue}
          filterOptions={true}
          className="category-glass-select"
        />
      </div>
      <button className="category-delete-btn" onClick={onRemove} title="Видалити категорію">
        <DeleteIcon size={16} />
      </button>
    </div>
  );
});

CategoryInput.displayName = 'CategoryInput';

export default CategoryInput;
